module.exports = __webpack_public_path__ + "media/icons/player5-66a89526.png";